import {
  stakePolicySchema,
  type StakePolicy,
  type StakePolicyKind,
  type StakeUnit,
} from '@gamble-chess/contracts';

/** What the stake fields hold while the user types; the amount is still text. */
export interface StakePolicyDraft {
  readonly kind: StakePolicyKind;
  readonly amount: string;
  readonly unit: StakeUnit;
}

export const initialStakePolicyDraft: StakePolicyDraft = {
  kind: 'fixed',
  amount: '10',
  unit: 'minutes',
};

export type ParsedStakePolicy =
  | { readonly ok: true; readonly policy: StakePolicy }
  | { readonly ok: false; readonly error: string };

/** Checks the fields against the same contract the server applies. */
export function parseStakePolicy(draft: StakePolicyDraft): ParsedStakePolicy {
  const parsed = stakePolicySchema.safeParse({
    kind: draft.kind,
    stake: { amount: Number(draft.amount), unit: draft.unit },
  });
  return parsed.success
    ? { ok: true, policy: parsed.data }
    : { ok: false, error: 'The stake must be a whole number from 1 to 1000.' };
}
